import { render, staticRenderFns } from "./ConditioningSuggestions.vue?vue&type=template&id=5b76cfbe&scoped=true&"
import script from "./ConditioningSuggestions.vue?vue&type=script&lang=js&"
export * from "./ConditioningSuggestions.vue?vue&type=script&lang=js&"
import style0 from "./ConditioningSuggestions.vue?vue&type=style&index=0&id=5b76cfbe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b76cfbe",
  null
  
)

export default component.exports